import { Action } from 'redux';

import { isActionFactory } from '../../app/actions/isActionFactory';
import { IContentInfo } from '../../ts/models/IContentInfo';

export const NewMetricForDatasource = 'NewMetricForDatasource';

export interface NewMetricForDatasourceAction extends Action {
  contentInfo: IContentInfo;
}

export function newMetricForDatasource(contentInfo: IContentInfo): NewMetricForDatasourceAction {
  return {
    type: NewMetricForDatasource,
    contentInfo
  };
}

export const isNewMetricForDatasourceAction = isActionFactory<NewMetricForDatasourceAction>(NewMetricForDatasource);
